import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { User } from './user.model';
import { UserInterface } from './user.interface';
import { UserFactory } from './user.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class UserService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<User>> {
        return this.http
            .get<UserInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/users`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => UserFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<User> {
        return this.http
            .get<UserInterface>(`${environment.apiUrl}/v${environment.apiVersion}/users/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => UserFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(user: User): Observable<any> {
        if (user.id) {
            return this.http
                .put(`${environment.apiUrl}/v${environment.apiVersion}/users/${user.id}`, user,
                    { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/users`, user,
                { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    register(user: User): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/auth/register`, user,
                { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    updateActive(userId: string, groupId: string, value: boolean): Observable<any> {
        return this.http
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/users/${userId}`, { groupId, active: value },
                { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    updateActiveChild(userId: string, childId: string, groupId: string, value: boolean): Observable<any> {
        return this.http
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/users/${userId}`, { groupId, childId, active: value },
                { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/users/${id}?isDeleted=true`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    restore(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/users/${id}?isDeleted=false`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    browseAs(id: string, activate: boolean): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/users/${id}/browse`, { activate }, { headers: this.authService.headers() })
            .pipe(map(item => UserFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    browseReset(id: string, activate: boolean): Observable<any> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/users/${id}/browsereset`, { activate }, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    getStep01(params: HttpParams): Observable<Array<any>> {
        return this.http
            .get<any[]>(`${environment.apiUrl}/v${environment.apiVersion}/users/step01`,
                { params, headers: this.authService.headers() })
            .pipe(map(data => data), catchError(this.errorHandler));
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<User>> {
        return this.http
            .get<UserInterface[]>(`${this.api}/users/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawUser => UserFactory.fromObject(rawUser)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/users/shared/user.service.ts